import React from 'react';
import {Router} from "../../api/address.api";
import './BroadbandRouter.css';

interface BroadbandRouterProps {
  router: Router;
  selectedRouter: Router | null;
  onSelect: (plan: Router) => void;
}

const BroadbandRouter: React.FC<BroadbandRouterProps> = ({ router, selectedRouter, onSelect }) => {

  const options: string[] = [];
  if (router.option_1) options.push(router.option_1);
  if (router.option_2) options.push(router.option_2);
  if (router.option_3) options.push(router.option_3);
  if (router.option_4) options.push(router.option_4);
  if (router.option_5) options.push(router.option_5);

  const isActive = selectedRouter?.router_id === router.router_id;

  return (
      <div
          className={`w-full lg:min-h-[38.25rem] bg-white border border-gray-200 rounded-lg col-span-full group md:col-span-1 group hover:bg-fred-blue-600 hover:cursor-pointer ${isActive ? 'active' : ''}`}
          onClick={() => onSelect(router)}>
        <div className="w-full px-4 py-2 sm:px-8 sm:py-4">
          <div className='flex justify-between items-center min-h-20'>
            <h5 className={`text-3xl font-semibold text-fred-purple-500 group-hover:text-white ${isActive ? 'active' : ''}`}>
              {router.cost_type === 'one-off' ? "New Router" : router.cost_type === 'monthly' ? "Rent Router" : ""}
            </h5>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                 stroke="currentColor"
                 className={`hidden w-12 h-12 group-hover:block group-hover:text-white ${isActive ? 'active' : ''}`}>
              <path stroke-linecap="round" stroke-linejoin="round"
                    d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z"/>
            </svg>
          </div>
          <div className="flex flex-col justify-center items-center gap-4 min-h-10">
            <img className="w-1/2" src={`images/${router.model_no}.png`} alt="Broadband router"/>
            <h6 className={`text-base font-normal leading-tight text-gray-500 ms-3 group-hover:text-gray-100 ${isActive ? 'active' : ''}`}>{router.name}</h6>
          </div>
          <div className={`price flex items-baseline ${isActive ? 'active' : ''}`}>
            <span className="text-3xl font-semibold text-fred-purple-500 group-hover:text-gray-100">$</span>
            <span
                className="text-4xl font-bold text-fred-purple-500 group-hover:text-gray-100">{router.cost_device ? router.cost_device / 100 : 0}</span>
            <span className="ms-1 text-xl font-normal text-gray-500 group-hover:text-gray-100">{router.cost_type === 'one-off' ? "/one-off" : router.cost_type === 'monthly' ? `/month` : ""}</span>
            {router.cost_type === 'monthly' && router.cost_term > 0 && (
              <span className="ml-1 text-sm font-semibold text-gray-500 group-hover:text-gray-100">{`(${router.cost_term}-month term applies)`}</span>
            )}
          </div>
          <ul role="list" className={`space-y-5 my-4 ${isActive ? 'active' : ''}`}>
            {options.map((option) => {
              return (
                <li className="flex items-center">
                  <svg className="flex-shrink-0 w-4 h-4 text-fred-blue-500 group-hover:text-gray-100"
                       aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                       viewBox="0 0 20 20">
                    <path
                        d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
                  </svg>
                  <span
                      className="text-base font-normal leading-tight text-gray-500 ms-3 group-hover:text-gray-100">{option}</span>
                </li>
              )
            })}
          </ul>
          <div>
            <p className={`text-xs font-medium italic group-hover:text-gray-100 ${isActive ? 'active' : ''}`}>{router.fine_print}</p>
          </div>
        </div>
      </div>
);
};

export default BroadbandRouter;
